import axios from 'axios';
import { Control, Controls } from 'model/Assessment/Control';

export const getAll = async (workspaceUuid: string): Promise<Control[]> => {
  const { data } = await axios.get(`/controls/`, {
    params: { ...(workspaceUuid ? { workspace_uuid: workspaceUuid } : {}) },
  });
  return data.results.map(Controls.mapToControl);
};
